// @flow
import * as React from 'react'
import MediaQuery from 'react-responsive'
import { BREAKPOINT } from './breakpoint'

type Props = {
  children: React.Node,
}

export default class MobileMediaQuery extends React.Component<Props> {
  render = () => {
    return <MediaQuery maxWidth={BREAKPOINT - 1}>{this.props.children}</MediaQuery>
  }
}
